import { DefaultState } from 'store/types';

export const DELETE_CORPORATE_CLIENT_REQUEST = 'DELETE_CORPORATE_CLIENT_REQUEST';
export const DELETE_CORPORATE_CLIENT_SUCCESS = 'DELETE_CORPORATE_CLIENT_SUCCESS';
export const DELETE_CORPORATE_CLIENT_FAILURE = 'DELETE_CORPORATE_CLIENT_FAILURE';

export interface DeleteCorporateClientData {

};

export type DeleteCorporateClientState = DefaultState & {
  contents?: DeleteCorporateClientData;
};

interface DeleteCorporateClientRequest {
  type: typeof DELETE_CORPORATE_CLIENT_REQUEST;
};

interface DeleteCorporateClientSuccess {
  type: typeof DELETE_CORPORATE_CLIENT_SUCCESS,
  contents: DeleteCorporateClientData;
}

interface DeleteCorporateClientFailure {
  type: typeof DELETE_CORPORATE_CLIENT_FAILURE;
}

export type DeleteCorporateClientActionTypes = DeleteCorporateClientRequest | DeleteCorporateClientSuccess | DeleteCorporateClientFailure;